import React, { useState, useEffect, useRef } from "react";
import "./login.css";
import Button from "../UIComponents/Button";
import ConfirmationModal from "../modals/ConfirmationModal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { servicePost } from "../../helper/api";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const EmailVerification = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [checkVerified, setCheckVerified] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const query = useQuery();
  const token = query.get("token");
  const { id } = useParams();

  const apiCallMade = useRef(false);

  useEffect(() => {
    if (token && !apiCallMade.current) {
      apiCallMade.current = true; // Set the flag to prevent further calls
      verifyEmailToken(token);
    } else if (!token) {
      setError("Invalid or missing token.");
    }
  }, [token]);

  const verifyEmailToken = async (token) => {
    try {
      const decoded = jwtDecode(token);
      const accountId = decoded?.data?.id;
      const currentTime = Date.now() / 1000;

      if (decoded.exp < currentTime) {
        console.warn("Access token expired");
        setError("Token expired. Please sign up again.");
        setCheckVerified(false);
      } else {
        const response = await servicePost("auth/emailverification", {
          accountId,
        });

        console.log("response", response);

        if (response.isExpired) {
          setError(
            "Token expired. This token is valid only once. If you open the link again or refresh the page, don't worry—your account is already verified. Please log in"
          );
          setCheckVerified(false);
        } else {
          setCheckVerified(true);
        }
      }
    } catch (err) {
      setError("An error occurred during token verification.");
      setCheckVerified(false);
    }
  };

  const goToLogin = () => {
    setShowConfirmationModal(true);
    setTimeout(() => {
      setShowConfirmationModal(false);
      navigate("/login");
    }, 3000);
  };

  const goToSignup = () => {
    navigate("/login");
  };

  return (
    <>
      <ConfirmationModal
        show={showConfirmationModal}
        onHide={() => setShowConfirmationModal(false)}
        icon="./assets/confirm-tick.png"
        type="Sign up"
        content="Your Account Successfully Created"
        showCloseIcon={true}
      />

      {error ? (
        <div className="login-main-wrapper email-confirmation-wrapper">
          <div className="login-main-wrap container">
            <div className="email-confirmation-icon">
              <img src="./assets/icons/expired-token.png" alt="icon" />
            </div>
            <h3>Email Verification</h3>
            <p>{error}</p>
            <div className="login-button">
              <Button
                onClick={goToSignup}
                isLoading={isLoading}
                label="Login"
              />
            </div>
          </div>
        </div>
      ) : checkVerified ? (
        <div className="login-main-wrapper email-confirmation-wrapper">
          <div className="login-main-wrap container">
            <div className="email-confirmation-icon">
              <img src="./assets/icons/email-confirmation.png" alt="icon" />
            </div>
            <h3>Email Verification</h3>
            <p>Thank you! Your email has been verified, please login.</p>
            <div className="login-button">
              <Button
                onClick={goToLogin}
                isLoading={isLoading}
                label="Sign In"
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="login-main-wrapper email-confirmation-wrapper">
          <div className="login-main-wrap container">
            <div className="email-confirmation-icon">
              <img src="./assets/icons/email-confirmation.png" alt="icon" />
            </div>
            {/* <h3>Email Verification</h3>
            <p>Your Token Expired. Please sign up again.</p> */}
            <h3>Email Verification</h3>
            <p>Thank you! Your email has been verified, please login.</p>
            <div className="login-button">
              <Button
                onClick={goToSignup}
                isLoading={isLoading}
                label="Login"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EmailVerification;
